"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var bind_1 = require("../bind");
var scrollto_with_animation_1 = require("scrollto-with-animation");
var sanitized_render_1 = require("./sanitized_render");
var classNames = require('classnames');
var OverflowingRow = /** @class */ (function (_super) {
    tslib_1.__extends(OverflowingRow, _super);
    function OverflowingRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            leftControlEnabled: false,
            rightControlEnabled: false,
            controlsVisible: false,
        };
        return _this;
    }
    OverflowingRow.prototype.componentDidMount = function () {
        this.setControlVisibility();
    };
    OverflowingRow.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.collectionCount !== this.props.collectionCount) {
            this.setControlVisibility();
        }
    };
    OverflowingRow.prototype.setControlVisibility = function () {
        if (!this.innerDiv || !this.outerDiv) {
            return false;
        }
        this.setState({
            controlsVisible: this.shouldDisplayControls(),
            leftControlEnabled: this.shouldEnableLeftControl(),
            rightControlEnabled: this.shouldEnableRightControl(),
        });
    };
    OverflowingRow.prototype.scrollLeft = function () {
        this.scrollToOffset(this.innerDiv.scrollLeft - this.getScrollDistance());
    };
    OverflowingRow.prototype.scrollRight = function () {
        this.scrollToOffset(this.innerDiv.scrollLeft + this.getScrollDistance());
    };
    OverflowingRow.prototype.getScrollDistance = function () {
        return this.innerDiv.offsetWidth * 0.85;
    };
    OverflowingRow.prototype.scrollToOffset = function (offset) {
        scrollto_with_animation_1.default(this.innerDiv, 'scrollLeft', offset, 400, 'easeInOutSine');
    };
    OverflowingRow.prototype.shouldDisplayControls = function () {
        return this.innerDiv.offsetWidth < this.innerDiv.scrollWidth;
    };
    OverflowingRow.prototype.shouldEnableLeftControl = function () {
        return this.innerDiv.scrollLeft > 0;
    };
    OverflowingRow.prototype.shouldEnableRightControl = function () {
        return (this.innerDiv.offsetWidth + this.innerDiv.scrollLeft) < this.innerDiv.scrollWidth - 120;
    };
    OverflowingRow.prototype.renderAction = function () {
        if (!this.props.action) {
            return null;
        }
        return (React.createElement("div", { className: "overflowing-row__action" }, this.props.action));
    };
    OverflowingRow.prototype.renderSubtitle = function () {
        if (!this.props.subtitle && !this.props.subtitleHtml)
            return;
        if (this.props.subtitleHtml) {
            return (React.createElement("small", { className: "d-block" },
                React.createElement(sanitized_render_1.default, { html: this.props.subtitleHtml })));
        }
        return (React.createElement("small", { className: "d-block" }, this.props.subtitle));
    };
    OverflowingRow.prototype.renderHeading = function () {
        if (!this.props.titleHtml && !this.props.title) {
            return null;
        }
        if (this.props.titleHtml) {
            return (React.createElement("h2", { className: "overflowing-row__heading" },
                React.createElement(sanitized_render_1.default, { html: this.props.titleHtml }),
                this.renderSubtitle()));
        }
        return (React.createElement("h2", { className: "overflowing-row__heading" },
            this.props.title,
            this.renderSubtitle()));
    };
    OverflowingRow.prototype.renderLede = function () {
        if (!this.props.ledeHtml)
            return;
        return (React.createElement(sanitized_render_1.default, { className: "overflowing-row__lede", htmlTag: "div", html: this.props.ledeHtml }));
    };
    OverflowingRow.prototype.render = function () {
        var _this = this;
        var classes = classNames('overflowing-row', { 'overflowing-row--centered': this.props.centeredTitle }, { 'overflowing-row--append-action': this.props.appendAction }, { 'overflowing-row--narrow': this.props.narrow }, { 'overflowing-row--hide-controls': !this.state.controlsVisible }, { 'overflowing-row--disable-left-control': !this.state.leftControlEnabled }, { 'overflowing-row--disable-right-control': !this.state.rightControlEnabled });
        return (React.createElement("div", { className: classes, id: this.props.id || null },
            React.createElement("div", { className: "overflowing-row__inner" },
                this.renderHeading(),
                this.renderAction(),
                this.renderLede(),
                React.createElement("div", { className: "overflowing-row__items", ref: function (div) { return _this.outerDiv = div; } },
                    React.createElement("div", { className: "overflowing-row__items__inner", ref: function (div) { return _this.innerDiv = div; }, onScroll: this.setControlVisibility }, this.props.children),
                    React.createElement("div", { className: "overflowing-row__control overflowing-row__control--left", onClick: this.scrollLeft }),
                    React.createElement("div", { className: "overflowing-row__control overflowing-row__control--right", onClick: this.scrollRight })))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], OverflowingRow.prototype, "setControlVisibility", null);
    tslib_1.__decorate([
        bind_1.default
    ], OverflowingRow.prototype, "scrollLeft", null);
    tslib_1.__decorate([
        bind_1.default
    ], OverflowingRow.prototype, "scrollRight", null);
    return OverflowingRow;
}(React.Component));
exports.default = OverflowingRow;
//# sourceMappingURL=overflowing_row.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/overflowing_row.js
// module id = KqRz
// module chunks = 20 21